import React from 'react'
import { compose } from 'redux';
import { connect } from 'react-redux';
import toJS from '../hoc/toJS';
import { CLI_CLUSTER_CINEMA_OPTION, CLI_CURRENT_CINEMA_ID, PROGRAM_CINEMAS, TRANSLATION_TIMEZONE } from '../constants/state'
import setMomentDateObjZero from '../functions/setMomentDateObjZero';
import getMomentNow from '../functions/getMomentNow';
import MovieTimesPeriodeDaysAccess from './MovieTimesPeriodeDaysAccess';
import getData from '../functions/getData';
import { useExpanded } from '../Accessibility/Core/useExpanded';






const mapStateToProps = (state) => ({
    currentCinemaId: getData(state, CLI_CURRENT_CINEMA_ID),
    clusterCinemaOption: getData(state, CLI_CLUSTER_CINEMA_OPTION),
    cinemas: getData(state, PROGRAM_CINEMAS),
    timezone: getData(state, TRANSLATION_TIMEZONE),
})


const MovieTimesContainerAccess = ({
    timesId,
    movieTitle,
    alternativeLinks,
    purchaseblePerformances,
    fullyfilteredPerformance,
    currentCinemaId,
    clusterCinemaOption,
    cinemas,
    timezone

}) => {
    const [expandedId, toggleExpanded] = useExpanded()
    const today = setMomentDateObjZero(getMomentNow(timezone))


    return (
        <MovieTimesPeriodeDaysAccess
            timesId={timesId}
            movieTitle={movieTitle}
            alternativeLinks={alternativeLinks}
            today={today}
            timezone={timezone}
            performances={fullyfilteredPerformance}
            currentCinemaId={currentCinemaId}
            clusterCinemaOption={clusterCinemaOption}
            cinemas={cinemas}
            activePerformanceId={expandedId}
            onToggleActivePerformanceId={toggleExpanded}

        />
    )
}


export default compose(
    connect(mapStateToProps, null),
    toJS()
)(MovieTimesContainerAccess)